import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-check-badge',
    templateUrl: './icon-check-badge.component.html',
    styleUrls: ['./icon-check-badge.component.scss'],
    standalone: false
})
export class IconCheckBadgeComponent {
  @Input() color = '#2F609F';
  @Input() width = '20';
  @Input() height = '20';
}
